import { render, staticRenderFns } from "./tradeOrder.vue?vue&type=template&id=086efc1a&scoped=true"
import script from "./tradeOrder.vue?vue&type=script&lang=js"
export * from "./tradeOrder.vue?vue&type=script&lang=js"
import style0 from "./tradeOrder.vue?vue&type=style&index=0&id=086efc1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086efc1a",
  null
  
)

export default component.exports